import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { MappedData, actions as documentActions } from '@redux/modules/documents';
import useSelector from '@redux/typedHooks';

const STALE_THRESHOLD_MS = 1800000; // 30 minutes

const initialState: MappedData = { meta: { fetchedAt: undefined, isUpdating: true, isLoggedin: undefined } };

export const useDocumentData = (slug: string, token?: string) => {
  const { isAuthenticated } = useAuth0();
  const { meta, data, error } = useSelector((state) => state.documents.mappedData[slug]) || {};
  const { fetchedAt, isLoggedin, isUpdating } = meta || {};

  const dispatch = useDispatch();

  useEffect(() => {
    const now = new Date().getTime();
    const age = (fetchedAt && now - new Date(fetchedAt).getTime()) || 0;
    const isStale = !fetchedAt || age > STALE_THRESHOLD_MS;
    const wasServerSideFetch = !isLoggedin && typeof token === 'string';

    // Skip while in flight: the request sets `isLoggedin`, which re-runs this effect.
    if (slug && (!isAuthenticated || typeof token === 'string') && !error && !isUpdating) {
      if (isStale || wasServerSideFetch) {
        dispatch(documentActions.getDocument.request(slug, { token }));
      }
    }
  }, [slug, token, dispatch, isAuthenticated, fetchedAt, isLoggedin, isUpdating, error]);

  return meta ? { meta, data } : initialState;
};
